import React from "react";

export default function NewYearFrame7({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-7ne1{fill:#fb9581}.cls-7ne5{fill:none;stroke:#000;stroke-miterlimit:10;stroke-linecap:round;stroke-width:3.34px}.cls-7ne6{fill:#458671}.cls-7ne7{fill:#7ca597}.cls-7ne11{fill:#8cd3b9}"
            }
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_10"
          data-name="\u0421\u043B\u043E\u0439 10"
        >
          <path
            d="m346.38 301.57 730.1-6 367.15-2.57 367.94-1.89 10.43-.05v10.52l1.27 366.3.9 366.3.53 366.29.18 366.3v13.36h-13.36l-366.3-.16-366.29-.52-366.3-.89-366.3-1.28h-10.55l.05-10.47 1.88-367.94 2.56-367.17Zm0 0 6.07 735.11 2.55 365.43 1.88 364.65-10.51-10.51 366.3-1.27 366.3-.89 366.29-.53 366.3-.16-13.35 13.36.18-366.3.53-366.29.9-366.3 1.27-366.3 10.48 10.43-364.66-1.88-365.43-2.55Z"
            className="cls-7ne1"
          />
          <path
            d="M381.43 1767.6s-151.77-20.14-143.91-156.44 137.46-309.78 175-212.81-159 70.57-175-18.55 140.12-205.08 143.91-286.93-172.43-58-127-197.82c36-110.55 134.62-197.15 154.12-183.9 7.91 5.37 5.5 29.82-6.55 40.88-10.35 9.51-26.22 7.65-30.07 7.2-43.05-5.05-132.27-108-99.31-194C313.59 458.48 432.23 438 417.25 356.16 404.57 286.86 371 208 341 211c-15.1 1.52-30.26 24.11-27.36 42.87 8.05 52 158.62 97.36 252.39 47.73 25.69-13.59 22.28-24.87 43.92-28.08 62.93-9.31 120.38 102.41 198.24 69S925.41 234.8 985.45 230.88c13.83-.91 24.22 3.12 44.38 9.32 137.17 42.17 168.4 121.06 231.92 116 74-5.94 138.08-121.47 120.34-145.08-9.92-13.21-52-6.37-58.35 10.82-10.43 28 65.14 107.65 142.65 109.25 88.1 1.82 119-98.38 197.78-96.42 37.94 1 88.67 25.6 147.4 126"
            style={{
              strokeWidth: "6.68px",
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 10,
            }}
          />
          <circle cx={189.98} cy={1369.84} r={41.87} className="cls-7ne1" />
          <path
            d="M160.42 1358.92a36.65 36.65 0 0 1 19.88-15.69c18.12-5.63 33.14 6.27 34.38 7.29"
            style={{
              strokeWidth: "2.65px",
              strokeLinecap: "round",
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 10,
            }}
          />
          <circle cx={982.7} cy={181.33} r={49.18} className="cls-7ne1" />
          <path
            d="M982.93 144.31c3.7.77 16.35 3.89 25.29 15.68 13.46 17.76 6.32 39.11 5.7 40.89"
            style={{
              strokeWidth: "3.11px",
              strokeLinecap: "round",
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 10,
            }}
          />
          <circle cx={1778.45} cy={230.73} r={52.87} className="cls-7ne1" />
          <path
            d="M1778.7 190.93c4 .83 17.57 4.18 27.18 16.86 14.47 19.09 6.8 42 6.13 43.94"
            className="cls-7ne5"
          />
          <circle cx={337.45} cy={1691.31} r={52.87} className="cls-7ne6" />
          <path
            d="M330.4 1730.47c-3.78-1.5-16.6-7.12-23.9-21.26-11-21.28.49-42.58 1.48-44.34"
            className="cls-7ne5"
          />
          <circle cx={436.15} cy={1069.67} r={52.87} className="cls-7ne7" />
          <path
            d="M429.1 1108.83c-3.78-1.49-16.6-7.12-23.9-21.25-11-21.29.49-42.58 1.48-44.35"
            className="cls-7ne5"
          />
          <circle cx={781.65} cy={410.96} r={60.41} className="cls-7ne7" />
          <path
            d="M739.66 428.42c-.9-4.56-3.43-20.35 5.63-36.11 13.65-23.73 41.21-25.88 43.52-26"
            style={{
              strokeWidth: "3.82px",
              strokeLinecap: "round",
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 10,
            }}
          />
          <circle cx={230.77} cy={546.2} r={43.72} className="cls-7ne6" />
          <path
            d="M211.12 519.8a38.29 38.29 0 0 1 26.35-2.4c19 5.4 25.41 24.38 25.91 26"
            style={{
              strokeWidth: "2.76px",
              strokeLinecap: "round",
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 10,
            }}
          />
          <circle cx={1485.81} cy={378.13} r={42.69} className="cls-7ne6" />
          <path
            d="M1468.8 405.39a37.45 37.45 0 0 1-11.56-23.1c-1.87-19.25 13.12-31.79 14.39-32.81"
            style={{
              strokeWidth: "2.7px",
              strokeLinecap: "round",
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 10,
            }}
          />
          <ellipse
            cx={471.67}
            cy={295.28}
            className="cls-7ne11"
            rx={28.53}
            ry={13.34}
            transform="rotate(-49.21 471.692 295.282)"
          />
          <ellipse
            cx={271.06}
            cy={701.14}
            className="cls-7ne11"
            rx={13.34}
            ry={28.53}
            transform="rotate(-72.53 271.077 701.16)"
          />
          <ellipse
            cx={277.03}
            cy={1227.86}
            className="cls-7ne11"
            rx={13.34}
            ry={28.53}
          />
          <ellipse
            cx={1231.99}
            cy={375.72}
            className="cls-7ne11"
            rx={13.34}
            ry={28.53}
            transform="rotate(-23.48 1232.113 375.726)"
          />
          <ellipse
            cx={1669.41}
            cy={263.17}
            className="cls-7ne11"
            rx={13.34}
            ry={28.53}
            transform="rotate(-23.48 1669.558 263.16)"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
